import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { Notification } from "models/Notification";
import { SysMessage } from "models/user/user";

export class NotificationsAPI {
  static async fetchNotifications(): Promise<Notification[]> {
    const response = await request
      .get(config.api.user.notifications)
      .set("Authorization", "Bearer " + getTabToken());
    const result: Notification[] = response.body;
    return result;
  }

  static async addToCustomerResponseAccepted(id: string) {
    return request
      .put(config.api.user.notificationAccepted(id))
      .set("Authorization", `Bearer ${getTabToken()}`);
  }

  static async addToCustomerResponseRejected(id: string) {
    return request
      .put(config.api.user.notificationRejected(id))
      .set("Authorization", `Bearer ${getTabToken()}`);
  }

  static async deleteNotification(id: string) {
    return request
      .delete(config.api.notifications.deleteSystemMessage(id))
      .set("Authorization", `Bearer ${getTabToken()}`);
  }

  static async sendSystemMessage(
    message: string,
    hours: string
  ): Promise<Notification> {
    const response = await request
      .post(config.api.notifications.systemMessage)
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        message: message,
        validInHours: hours
      });
    const result: Notification = response.body;
    return result;
  }

  static async sendSystemMessageExternal(sysMessage: {
    message: string;
    hours: string;
  }): Promise<SysMessage> {
    const response = await request
      .post(config.api.sysMessageExternal.put)
      .set("Accept", "application/json")
      .set("Authorization", "Bearer " + getTabToken())
      .send({
        message: sysMessage.message,
        validInHours: sysMessage.hours
      });
    const sysMessageResult: SysMessage = response.body;
    return sysMessageResult;
  }

  static async fetchSysMessage() {
    const response = await request
      .get(config.api.sysMessageExternal.get)
      .set("Accept", "application/json")
      .send();

    return response.body;
  }
}
